<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="旧件回收" size="40%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :model="formData" label-width="120px">
              <el-form-item label="收货人" :rules="[{ required: true, trigger: 'blur' }]">
                <el-input type="text" autocomplete="off" v-model="formData.recoveryReceiveMan"  style="width:8vw!important ;"  clearable />
              </el-form-item>
              <el-form-item label="收货人电话" :rules="[{ required: true, trigger: 'blur' }]">
                <el-input type="text" autocomplete="off" v-model="formData.recoveryReceiveMobile"   style="width:8vw!important ;" clearable />
              </el-form-item>
              <el-form-item label="收货人地址" :rules="[{ required: true, trigger: 'blur' }]">
                <el-cascader style="width: 25vw!important;" :props="areaProps" v-model="areaValues" :clearable="true"
                             @change="handleChange" ref="cascader" :options="areaOption" >
                </el-cascader>
              </el-form-item>
              <el-form-item label="收货人详细地址" :rules="[{ required: true, trigger: 'blur' }]">
                <el-input type="text" autocomplete="off" v-model="formData.recoveryReceiveAddress"   style="width:8vw!important ;" clearable />
              </el-form-item>
              <el-form-item label="机器入库时间" :rules="[{ required: true, trigger: 'blur' }]">
                <el-date-picker v-model="formData.recoveryInTime" type="date" placeholder="选择日期"
                                style="width: 8vw;" :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="产品打包图片1" :rules="[{ required: true, trigger: 'blur' }]">
                <photo-upload :photo-url.sync="formData.recoveryPackPic1" />
              </el-form-item>
              <el-form-item label="产品打包图片2" :rules="[{ required: true, trigger: 'blur' }]">
                <photo-upload :photo-url.sync="formData.recoveryPackPic2" />
              </el-form-item>
              <el-form-item label="产品打包图片3" :rules="[{ required: true, trigger: 'blur' }]">
                <photo-upload :photo-url.sync="formData.recoveryPackPic3" />
              </el-form-item>
              <el-form-item label="产品打包图片4" >
                <photo-upload :photo-url.sync="formData.recoveryPackPic4" />
              </el-form-item>
              <el-form-item label="产品打包图片5" >
                <photo-upload :photo-url.sync="formData.recoveryPackPic5" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="doCommit">
            确 定
          </el-button>
        </div>
    </el-drawer>

  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'

import api from "@/api/projectApi";
import PhotoUpload from "@/components/formItem/photoUpload.vue";

export default {
  components: {PhotoUpload},
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'exchangeOrderId', 'commentDrawTitle', 'rejectType'],
  created() {
    this.formData.exchangeOrderId = this.exchangeOrderId
  },
  data() {
    return {
      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      areaOption: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > new Date().getTime();
        },
      },
      url :null,
      title:null,
      formData: {
        exchangeOrderId: null,
        recoveryReceiveMan: null,
        recoveryReceiveMobile:null,
        recoveryReceiveProvince:null,
        recoveryReceiveCity:null,
        recoveryReceiveCounty:null,
        recoveryReceiveTown:null,
        recoveryReceiveAreaId:null,
        recoveryReceiveAddress:null,
        recoveryInTime:null,
        recoveryPackPic1:null,
        recoveryPackPic2:null,
        recoveryPackPic3:null,
        recoveryPackPic4:null,
        recoveryPackPic5:null,


      },
      drawer: true,
    }
  },
  methods: {
    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 2) {
          this.formData.recoveryReceiveProvince = areaNode[0].label;
          this.formData.recoveryReceiveCity = null;
          this.formData.recoveryReceiveCounty = null;
          this.formData.recoveryReceiveTown = null;
        } else if (areaNode[0].level == 3) {
          this.formData.recoveryReceiveCity = areaNode[0].label;
          this.formData.recoveryReceiveCounty = null;
          this.formData.recoveryReceiveTown = null;
        } else if (areaNode[0].level == 4) {
          this.formData.recoveryReceiveCounty = areaNode[0].label;
          this.formData.recoveryReceiveTown = null;
        } else if (areaNode[0].level == 5) {
          this.formData.recoveryReceiveTown = areaNode[0].label;
        }
        this.formData.recoveryReceiveAreaId = areaNode[0].value
      } else {
        this.formData.recoveryReceiveAreaId = null;
        this.formData.recoveryReceiveProvince = null;
        this.formData.recoveryReceiveCity = null;
        this.formData.recoveryReceiveCounty = null;
        this.formData.recoveryReceiveTown = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
    // 提交
    doCommit() {
      if(!this.formData.recoveryReceiveMan){
        this.$message.error("请输入收货人姓名")
        return
      }
      if(!this.formData.recoveryReceiveMobile){
        this.$message.error("请输入收货人电话")
        return
      }
      if(!this.formData.recoveryReceiveAreaId){
        this.$message.error("请选择收货人地址")
        return
      }
      if(!this.formData.recoveryReceiveAddress){
        this.$message.error("请输入收货人详细地址")
        return
      }
      if(!this.formData.recoveryInTime){
        this.$message.error("请输入机器入库时间")
        return
      }
      if(!this.formData.recoveryPackPic1){
        this.$message.error("请上传产品打包图片1")
        return
      }
      if(!this.formData.recoveryPackPic2){
        this.$message.error("请上传产品打包图片2")
        return
      }
      if(!this.formData.recoveryPackPic3){
        this.$message.error("请上传产品打包图片3")
        return
      }
      this.$baseConfirm('您确定要提交吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkExchangeOrder.doOldItemRecoveryUrl,
          method: 'post',
          data: this.formData,
          isLoading: true,
        }).then(res => {
          this.$message.success('操作成功')
          this.$emit('closeDialog', true)
        }).catch(() => {
          this.$message.error("操作失败！");
          this.$mask.close()
        });
      })
    },




    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.handleClose()
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeDialog', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
